var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowNoPadding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1714 15.3105C10.8124 15.9302 10.8124 16.9345 10.1927 17.5755C9.87221 17.8961 9.46621 18.0456 9.03884 18.0456C8.63284 18.0456 8.22684 17.8961 7.92768 17.5755L0.470103 10.1607C0.170946 9.86153 -1.65326e-06 9.45553 -1.57853e-06 9.02816C-1.50381e-06 8.60079 0.170946 8.19479 0.470104 7.89563L7.92768 0.480791C8.54737 -0.160262 9.55168 -0.160261 10.1927 0.480791C10.8124 1.10048 10.8124 2.12616 10.1714 2.74584L3.86768 9.02816L10.1714 15.3105Z",
    fill: "#010202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowNoPadding);
export default __webpack_public_path__ + "static/media/LeftArrowNoPadding.9e83a6ccbca84624751b46ebf193296f.svg";
export { ForwardRef as ReactComponent };